export default __webpack_public_path__ + "static/media/jump2.943d93d6.mp3";